<script>
import InputMask from 'primevue/inputmask';
import Utils from '../../common/Utils';

export default {
    props: ['readonly', 'inputClass', 'modelValue'],
    //props: ['updateModel', 'updateField', 'readonly', 'inputClass'],
    components: {InputMask},
    data(){
        return{
            v: null
        }
    },
    created() {
        this.refreshValue();
        // this.v = Utils.formatDate(Utils.dateToCurrentTimeZone(this.updateModel[this.updateField]));
    },
    watch: {
        modelValue(){
            this.refreshValue();
        }
    },
    methods: {
        refreshValue(){
            this.v = this.modelValue ? Utils.formatDateTime(Utils.dateToCurrentTimeZone(this.modelValue)) : null;
        },
        updateModelValue(event){
            if(event){
                if(event.length == 8){
                    let day = parseInt(event.substr(0,2));
                    let month = parseInt(event.substr(2,2)) - 1;
                    let year = parseInt(event.substr(4,4));
                    let d = new Date(year, month, day, 0, 0, 0);
                    this.$emit('update:modelValue', Utils.dateToCurrentTimeZone(d));
                }
            }else{
                this.$emit('update:modelValue', null);
            }
        },
    }
}
</script>

<template>
    <main>
        <InputMask 
            v-model="v" 
            @update:modelValue="updateModelValue"
            mask="99/99/9999"
            :unmask="true"
            :disabled="readonly"
            :class="inputClass || 'w-full'"
             />
    </main>
</template>